import { IConnectSocket } from '@app-types/websocket/common.types';
import { createAction } from "redux-act";

export const initWebsocket = createAction<IConnectSocket>('Init websocket');
export const websocketAuthenticated = createAction('Websocket authenticated');
export const websocketError = createAction<any>('Websocket errror');
export const websocketDisconnected = createAction('Websocket disconnected');
export const websocketLoginFailed = createAction('Websocket login failed');
export const bootstrap = createAction<any>('Bootstrap app');



// WEBPACK FOOTER //
// ./src/services/common/common.action.ts